<div class="grid grid-cols-4 w-full h-full bg-transparent px-2">
  <ion-tab-button
    appRipple
    class="bg-transparent h-full"
    [routerLink]="'/home'"
    routerLinkActive="active-tab"
    #rlaHome="routerLinkActive"
  >
    <home-icon
      [color]="rlaHome.isActive ? 'var(--ion-color-primary)' : '#9ca3af'"
      [width]="'22'"
      [height]="'22'"
      class="mb-1"
    />
    <span class="text-[9px] font-bold uppercase tracking-widest transition-colors duration-300" 
          [class.text-primary]="rlaHome.isActive"
          [class.text-gray-400]="!rlaHome.isActive">Inicio</span>
  </ion-tab-button>

  <ion-tab-button
    appRipple
    class="bg-transparent h-full"
    [routerLink]="'/search-companies'"
    routerLinkActive="active-tab"
    #rlaEmpresas="routerLinkActive"
  >
    <div class="mb-1">
      <ion-icon name="business-outline" 
                [style.color]="rlaEmpresas.isActive ? 'var(--ion-color-primary)' : '#9ca3af'" 
                class="text-xl"></ion-icon>
    </div>
    <span class="text-[9px] font-bold uppercase tracking-widest transition-colors duration-300" 
          [class.text-primary]="rlaEmpresas.isActive"
          [class.text-gray-400]="!rlaEmpresas.isActive">Empresas</span>
  </ion-tab-button>

  <ion-tab-button
    appRipple
    class="bg-transparent h-full"
    [routerLink]="'/notifications'"
    routerLinkActive="active-tab"
    #rlaNotif="routerLinkActive"
    (click)="resetBadge()"
  >
    <div class="relative mb-1">
        <ion-icon name="notifications-outline" 
                  [style.color]="rlaNotif.isActive ? 'var(--ion-color-primary)' : '#9ca3af'" 
                  class="text-xl"></ion-icon>
        <notification-badge
          *ngIf="notificationNumber > 0"
          [notificationNumber]="notificationNumber"
          class="absolute -top-1 -right-1"
        />
    </div>
    <span class="text-[9px] font-bold uppercase tracking-widest transition-colors duration-300" 
          [class.text-primary]="rlaNotif.isActive"
          [class.text-gray-400]="!rlaNotif.isActive">Alertas</span>
  </ion-tab-button>

  <ion-tab-button
    appRipple
    class="bg-transparent h-full"
    [routerLink]="'/profile'"
    routerLinkActive="active-tab"
    #rlaProfile="routerLinkActive"
  >
    <user-icon
      [color]="rlaProfile.isActive ? 'var(--ion-color-primary)' : '#9ca3af'"
      [width]="'22'"
      [height]="'22'"
      class="mb-1"
    />
    <span class="text-[9px] font-bold uppercase tracking-widest transition-colors duration-300" 
          [class.text-primary]="rlaProfile.isActive"
          [class.text-gray-400]="!rlaProfile.isActive">Perfil</span>
  </ion-tab-button>
</div>
